import { StorageName } from "./../../../shared/enum/common-enum";
import { AgColDefsI, AgGridI } from "./../../../shared/common-components/ag-grid/ag-grid.model";
import { EditDeleteIconComponent } from "./../../../shared/common-components/ag-grid/edit-delete-icon/edit-delete-icon.component";
import { TextRendererComponent } from './../../../shared/common-components/ag-grid/text-renderer/text-renderer.component';
import { NumericCellRendererComponent } from "./../../../shared/common-components/ag-grid/numeric-cell-renderer/numeric-cell-renderer.component";
import { StorageService } from "../../../shared/services/storage.service";
import { AgGridCustomDropdownComponent } from "../../../shared/common-components/ag-grid/ag-grid-custom-dropdown/ag-grid-custom-dropdown.component";
import { CustomHeaderComponent } from "../../../shared/common-components/ag-grid/custom-header/custom-header.component";
import { AgGridCustomInputComponent } from "src/app/shared/common-components/ag-grid/ag-grid-custom-input/ag-grid-custom-input.component";
import { AgGridCustomSelect2Component } from "../../../shared/common-components/ag-grid/ag-grid-custom-select2/ag-grid-custom-select2.component";

export class Expenses {
}

const Category: AgColDefsI = {
    headerName: "Category", 
    headerClass: "px-0 custom-column-group-cell  text-gray-color f-14 font-semibold",        
    field: 'expensesCategoryId',
    sortable:true,
    editable:true,
    resizable: false,
    minWidth: 200,
    maxWidth: 200,
    lockPosition: false,
    cellRenderer:TextRendererComponent,
    cellEditor: AgGridCustomSelect2Component,
    headerComponentParams:{
      enableSorting: false,
      filterParams: StorageName.EXPENSES_LEDGER_CATEGORY_DROPDOWN
    },
    cellEditorParams: {
      values: () => {
        const storageService = new StorageService();
        const storage = StorageName;
        return storageService.retrieve(storage.EXPENSES_LEDGER_CATEGORY_DROPDOWN);
      },
    },
    cellClass: "custom-column-group-cell cursorPointer px-0",
    valueParser: (params) => String(params?.newValue || ''),
};

const Description: AgColDefsI = {
    headerName: "Description", 
    headerClass: "px-0 custom-column-group-cell  text-gray-color f-14 font-semibold",        
    field: 'description',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell',
    editable:true,
    lockPosition: false,
    cellRenderer:TextRendererComponent,
    headerComponentParams:{
      enableSorting: false,
    },
    resizable: true,
    minWidth: 120,
    maxWidth:700,
     flex: 2,
};
const Amount: AgColDefsI = {
    headerName: "Amount",
    field: "amount",
    resizable: false,
    sortable: true,
    flex:1,
    editable: true,
    lockPosition:false,
    isRequired: true,
    cellClass: 'px-2 cursorPointer custom-column-group-cell text-end text-primary',   
    headerClass: "px-1 custom-column-group-cell ag_header_end ",
    headerCheckboxSelection: false,
    headerComponentParams: { isRequired: true,enableSorting : false},
    cellRenderer: TextRendererComponent,
    cellEditor: AgGridCustomInputComponent,
    cellEditorParams: {
      decimalPlaces: 2,
      isOnlyNumbers: true,
    }
};

const Tax: AgColDefsI = {
    headerName: "Tax",
    field: "taxId",
    minWidth: 120,
    maxWidth:220,
    sortable: true,
    editable: true,
    lockPosition: false,
    isRequired: true,
    headerComponentParams: { isRequired: true, enableSorting : false},
    cellRenderer: TextRendererComponent,
    cellEditor: AgGridCustomDropdownComponent,
    cellEditorParams: {
      values: () => {
        const storageService = new StorageService();
        const storage = StorageName;
        return storageService.retrieve(storage.TAX_DROPDOWN);
      },
    },
    cellClass: "custom-column-group-cell px-0",
    headerClass: "custom-column-group-cell px-0",
    valueParser: (params) => String(params?.newValue || ''),
};
const TaxWithAmount: AgColDefsI = {
    headerName: "Tax With Amount",
    field: "netAmountWithTax",
    resizable: true,
    sortable: true,
    flex:1,
    editable: false,
    lockPosition: false,
    isRequired: true,
    headerComponentParams: { isRequired: true,enableSorting: false,},
    headerClass: "px-1 custom-column-group-cell ag_header_end ",
    headerCheckboxSelection: false,
    cellRenderer: NumericCellRendererComponent,
    cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',   
};
export const ExpensesActionColumn: AgColDefsI = {
  headerName: "",
  suppressNavigable: true,
  editable: false,
  pinned: "right",
  headerComponent: CustomHeaderComponent,
  headerClass: "justify-content-end custom-column-group-cell px-0",
  cellRenderer: EditDeleteIconComponent,
  cellClass: "custom-column-group-cell d-flex align-items-center justify-content-center",
  cellRendererParams: { focusOnColumn: "paymentType", isEditRowOnEdit: true , gridName : "expensesList" },
  headerComponentParams: { enableMenu: false, moreButton: true ,enableSorting: false ,moreButtonId:'addMoreExpensesBtn' ,deleteThroughApi : false},
  minWidth: 80,
  maxWidth: 80,
  lockPosition: 'right',
  lockPinned: true,
  suppressMovable:false,
  field : "action",
  extraField:"Action"
};
const ExpensesGridTable: AgColDefsI[] = [
    Category,
    Description,
    Amount,
    Tax,
    TaxWithAmount,
    ExpensesActionColumn
]

export const AgGridDataModelExpensesGrid: AgGridI = {
  colDefs: ExpensesGridTable,
  rowSelection: "multiple",
  storageName: StorageName.TRANSACTION_EXPENSES_GRID,
  columnSettings:true,
  moreButton:true,
  rows:[],
  rowHeight:28,
};

// export class ExpensesModel {
//     insertExpensesMasterModel: InsertExpensesMasterModel;
//     insertExpensesDetailsModel: InsertExpensesDetailsModel[];
//     paymentList: PaymentList[];
// }

export class InsertExpensesMasterModel {
    expensesWithTax: boolean
    accountLedgerId: number
    invoiceDate: string
    comment: string
    suffixPrefixId: number
    voucherNo: number
    voucherTypeId: number
    invoiceNo: string
    metalFix: boolean
    internalFix: boolean
  }
  
//   export class InsertExpensesDetailsModel {
//     expensesMasterId: number
//     expensesCategoryId: number
//     description: string
//     amount: number
//     taxId: number
//     taxWithAmount: number
//   }
  
//   export class PaymentList {
//     id: number
//     paymentMethodId: number
//     productDetailId: number
//     depositeIntoId: number
//     transferFromId: number
//     transactionNo: number
//     grossWt: number
//     purityPer: number
//     purityWt: number
//     rate: number
//     amount: number
//     chequeNo: string
//     chequeDate: string
//     paymentMasterId: number
//     metalId: number
//     item: string
//     metalName: string
//     itemCode: string
//     diamondStoneAgainstId: number
//     detailedJson: string
//     comment: string
//     groupName: string
//     isGroup: boolean
//     rowIndex: number
//     scrapInvoiceItemId: number
//     quantity: number
//   }

